import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { Form, FormGroup } from "react-bootstrap";
import _ from "lodash";
import Button from "../../../../components/common/button/Button";
import styles from "./EditInformation.scss";
import Input from "../../../../components/common/input/Input";
import Select2 from "../../../../components/common/select/Select2";
import Textarea from "../../../../components/common/textarea/Textarea";
import Typeahead from "../../../../components/common/typeahead/Typeahead";
import {
  required,
  dropdown,
  alphaSymbolicSpace,
  email,
  maxLength,
  minLength
} from "../../../../utils/forms/validators";
import * as userActions from "../../../../actions/user.actions";
import ScrollToTopOnMount from "../../../../utils/scroll/ScrollToTopOnMount";
import { EDIT_EMPLOYER_PROFILE_FORM } from "../../../../actions/user.actions";

const dropdownValidation = msg => dropdown(msg);
const maxLengthValidation = (max, msg) => maxLength(max, msg);

const firstName = alphaSymbolicSpace("Please enter a valid first name.");
const lastName = alphaSymbolicSpace("Please enter a valid last name.");
const emailVal = email("Please enter a valid email address.");
const password = minLength(8, "Password must be at least 8 characters.");
const industry = dropdownValidation("Please select an Industry.");
const companySize = dropdownValidation("Please select a Company Size.");
const summary = maxLengthValidation(
  280,
  "Summary must be less than or equal to 280 characters."
);

class EditInformation extends Component {
  componentDidMount() {
    this.props.userActions.getUserData();
  }

  render() {
    const {
      handleSubmit,
      submitting,
      valid,
      cities,
      onSearchCities,
      isLoading,
      industries,
      companySizes
    } = this.props;

    const selectedCityProps = {};
    if (this.props.defaultLocation) {
      selectedCityProps.selected = [this.props.defaultLocation];
    }

    return (
      <section className={styles.editInformation}>
        <ScrollToTopOnMount />
        <div className={styles.content}>
          <h2 className={styles.title}>Edit Account Information</h2>

          <Form onSubmit={handleSubmit}>
            <div className={styles.form}>
              <FormGroup />
              <FormGroup>
                <div className={styles.sectionTitle}>Personal Information</div>

                <Field
                  name="first_name"
                  type="text"
                  placeholder="First Name"
                  component={Input}
                  validate={[required, firstName]}
                  autoFocus={true}
                />

                <Field
                  name="last_name"
                  type="text"
                  placeholder="Last Name"
                  component={Input}
                  validate={[required, lastName]}
                />

                <Field
                  name="email"
                  type="text"
                  placeholder="Email Address"
                  component={Input}
                  validate={[required, emailVal]}
                />

                <Field
                  name="password"
                  type="password"
                  placeholder="Change Password"
                  component={Input}
                  validate={[password]}
                  showPasswordIcon
                  autoComplete="off"
                />

                <div className={styles.sectionTitle}>Company Information</div>

                <Field
                  name="company"
                  type="text"
                  placeholder="Company Name"
                  component={Input}
                  validate={[required]}
                />

                <Field
                  name="industry_id"
                  type="select"
                  placeholder="Industry"
                  component={Select2}
                  options={industries}
                  validate={industry}
                />

                <Field
                  name="company_size_id"
                  type="select"
                  placeholder="Company Size"
                  component={Select2}
                  options={companySizes}
                  validate={companySize}
                />

                <Field
                  name="location"
                  type="text"
                  placeholder="Office Location (City, State)"
                  component={Typeahead}
                  isLoading={isLoading || false}
                  options={cities}
                  isAsync={true}
                  minLength={3}
                  allowNew={false}
                  labelKey="description"
                  valueKey="id"
                  icon="map-marker"
                  validate={required}
                  focusOut={selected => {
                    if (!selected) {
                      this.props.change("location", null);
                    }
                  }}
                  onSearch={query => onSearchCities(query)}
                  {...selectedCityProps}
                />

                <Field
                  name="url"
                  type="text"
                  placeholder="Website or LinkedIn Page"
                  component={Input}
                  validate={required}
                />

                <Field
                  name="summary"
                  type="textarea"
                  placeholder="Describe your company to prospective
                  freelancers and employees (you can edit this later)."
                  component={Textarea}
                  help={"Please enter a brief description of your company."}
                  maxlength={280}
                  label="Company Summary"
                  validate={[summary]}
                />

                <Button
                  isPrimary
                  type="submit"
                  size={"large"}
                  label="Save Changes"
                  isDisabled={!valid || submitting}
                />
              </FormGroup>
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

EditInformation = reduxForm({
  form: EDIT_EMPLOYER_PROFILE_FORM,
  enableReinitialize: true,
  touchOnBlur: true,
  touchOnChange: true
})(EditInformation);

const selector = formValueSelector(EDIT_EMPLOYER_PROFILE_FORM);
EditInformation = connect(
  state => {
    const user = state.user.data;
    const defaultLocation = selector(state, "location");
    return {
      user,
      defaultLocation,
      initialValues: {
        first_name: _.get(user, "first_name"),
        last_name: _.get(user, "last_name"),
        email: _.get(user, "email"),
        company: _.get(user, "profile.company.name"),
        industry_id: _.get(user, "profile.company.industry_id"),
        company_size_id: _.get(user, "profile.company.company_size_id"),
        location: _.get(user, "profile.company.location"),
        url: _.get(user, "profile.company.url"),
        summary: _.get(user, "profile.company.summary")
      }
    };
  },
  dispatch => ({
    userActions: bindActionCreators(userActions, dispatch)
  })
)(EditInformation);

export default EditInformation;



// WEBPACK FOOTER //
// ./src/routes/employer/editInformation/components/EditInformation.js